import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const keyPrefix = 'general_info';
export const useEventDetailsGeneralInfoTranslation = (): UseTranslationResponse<'entities', typeof keyPrefix> => (
  useTranslation('entities', { keyPrefix })
);

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Общая информация',
    event_type: 'Тип события',
    create_time: 'Создано',
    event_id: 'ID события',
    track_id: 'ID трека',
    handlers: 'Сценарий',
    source: 'Источник',
    stream_id: 'Название источника в момент события',
    match_by_list: 'Совпадение по списку',
    match_by_param: 'Совпадение по парам. сравнения',
    tags: 'Теги',
    liveness: 'Liveness',
    deepfake: 'Deepfake',
    deepfake_0: 'Поддельное лицо',
    deepfake_1: 'Реальное лицо',
    deepfake_null: 'Оценка не проводилась',
    liveness_0: 'Поддельное лицо',
    liveness_1: 'Живое лицо',
    liveness_2: 'Неизвестно',
    liveness_null: 'Оценка не проводилась',
    copy_button: 'Копировать',
    match: 'Совпадение',
    detection: 'Обнаружение',
    deleted: 'Удален',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'General information',
    event_type: 'Event type',
    create_time: 'Created',
    event_id: 'Event ID',
    track_id: 'Track ID',
    handlers: 'Scenario',
    source: 'Source',
    stream_id: 'Source name at the time of the event',
    match_by_list: 'Match by list',
    match_by_param: 'Match by comparison parameter',
    tags: 'Tags',
    liveness: 'Liveness',
    deepfake: 'Deepfake',
    deepfake_0: 'Fake face',
    deepfake_1: 'Real face',
    deepfake_null: 'Not estimated',
    liveness_0: 'Spoof',
    liveness_1: 'Real',
    liveness_2: 'Unknown',
    liveness_null: 'Not estimated',
    copy_button: 'Copy',
    match: 'Match',
    detection: 'Detection',
    deleted: 'Deleted',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Informações gerais',
    event_type: 'Tipo de evento',
    create_time: 'Criado em',
    event_id: 'ID do evento',
    track_id: 'ID da faixa',
    handlers: 'Cenário',
    source: 'Fonte',
    stream_id: 'Nome da fonte no momento do evento',
    match_by_list: 'Correspondência por lista',
    match_by_param: 'Correspondência por parâmetro de comparação',
    tags: 'Tags',
    liveness: 'Liveness',
    deepfake: 'Deepfake',
    deepfake_0: 'Rosto falso',
    deepfake_1: 'Rosto real',
    deepfake_null: 'Avaliação não realizada',
    liveness_0: 'Rosto falso (Spoof)',
    liveness_1: 'Rosto real',
    liveness_2: 'Desconhecido',
    liveness_null: 'Avaliação não realizada',
    copy_button: 'Copiar',
    match: 'Correspondência',
    detection: 'Detecção',
    deleted: 'Excluído',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Información general',
    event_type: 'Tipo de evento',
    create_time: 'Creado',
    event_id: 'ID del evento',
    track_id: 'ID de la pista',
    handlers: 'Escenario',
    source: 'Fuente',
    stream_id: 'Nombre de la fuente en el momento del evento',
    match_by_list: 'Coincidencia por lista',
    match_by_param: 'Coincidencia por parámetro de comparación',
    tags: 'Etiquetas',
    liveness: 'Liveness',
    deepfake: 'Deepfake',
    deepfake_0: 'Rostro falso',
    deepfake_1: 'Rostro real',
    deepfake_null: 'Evaluación no realizada',
    liveness_0: 'Rostro falso (Spoof)',
    liveness_1: 'Rostro real',
    liveness_2: 'Desconhecido',
    liveness_null: 'Evaluación no realizada',
    copy_button: 'Copiar',
    match: 'Coincidencia',
    detection: 'Detección',
    deleted: 'Eliminado',
  },
}) : {}) as Record<string, unknown>;
